import {DEVICE} from "./constants";

export const deviceCheck = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  var pcDevice = "win16|win32|win64|mac|macintel";
  const isMobile = pcDevice.indexOf(navigator.platform.toLowerCase()) < 0;
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) &&
    navigator.maxTouchPoints > 0;

  if (navigator.platform) {
    if (isMobile) {
      return DEVICE.MOBILE;
    } else if (isTablet) {
      return DEVICE.TABLET;
    } else {
      return DEVICE.PC;
    }
  }
};

export const isMobile = deviceCheck() === DEVICE.MOBILE;
export const isTablet = deviceCheck() === DEVICE.TABLET;
export const isPC = deviceCheck() === DEVICE.PC;

export const isKakaoInApp = navigator.userAgent.match("KAKAOTALK");
